import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import ScrollToTopButton from "../components/ScrollToTopButton";
import Reveal from "../components/Reveal";
import { toPersianOrdinal, toPersianDigits } from "../utils/persianDigits";
import { localizeTitle } from "../utils/textDirection";
import { getIssues } from "../api/issuesApi";
import { translateAuthError, API_ORIGIN } from "../api/authApi";

// Section A: public. "نشریه‌ها" — the archive of دریچه issue covers,
// newest (highest number) first. Backend-driven (see api/issuesApi.js
// and /admin/issues) so an admin can add a new issue's cover from the
// website without touching code.
function PublicationsPage() {
  const [issues, setIssues] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getIssues()
      .then(setIssues)
      .catch((err) => setError(translateAuthError(err.message)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="site">
      <SiteHeader />

      <main>
        <div className="dimension-divider">
          <span className="dimension-line" />
          <span className="dimension-label">{toPersianDigits(issues.length)} شماره</span>
          <span className="dimension-line" />
        </div>

        {error && <p className="error">{error}</p>}
        {!loading && issues.length === 0 && !error && <p className="admin-empty">هنوز شماره‌ای ثبت نشده است.</p>}

        <section className="pub-grid">
          {issues.map((issue, index) => {
            const { dir: titleDir, text: titleText } = localizeTitle(issue.title);
            return (
              <Reveal key={issue.id} delay={index * 80}>
                <Link to={`/issues/${issue.id}`} className="pub-card-link">
                  <article className="feature-card pub-card pub-card--magazine">
                    <span className="corner corner-tr" />
                    <span className="corner corner-tl" />
                    <span className="corner corner-br" />
                    <span className="corner corner-bl" />

                    <div className="pub-cover-frame">
                      <img
                        className="pub-cover"
                        src={`${API_ORIGIN}${issue.image_path}`}
                        alt={`جلد شمارهٔ ${issue.title}`}
                      />
                    </div>

                    <div className="deck-card-head">
                      <span className="deck-index">شمارهٔ {toPersianOrdinal(issue.number)}</span>
                      <h2 dir={titleDir}>{titleText}</h2>
                    </div>
                  </article>
                </Link>
              </Reveal>
            );
          })}
        </section>
      </main>

      <SiteFooter />
      <ScrollToTopButton />
    </div>
  );
}

export default PublicationsPage;
